// Module
var code = " <h4>How to view the Journal Entries?</h4> <div class=\"button\" data-value=\"byAccount\">by Account</div> <div class=\"button\" data-value=\"detailedEntries\">See all entries</div> ";
// Exports
export default code;